import React, {useState, useRef} from "react";

const DataContext = React.createContext();

function DataProvider(props) {
	// Global data
	const [requestVariables, setRequestVariables] = useState({demanda: [], idioma: [], est_mercados: [], ecommerce: [], logistica: [], acceso: []});
	const [activeCountries, setActiveCountries] = useState([false, false, false]);
	const [showedScreen, setShowedScreen] = useState(1);

	// Special responsive cases
	let widthRef = useRef();
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);
	const [tableWidth, setTableWidth] = useState(0);
	const [pageHeight, setPageHeight] = useState(0);

	window.onresize = () => {
		setIsMobile(window.innerWidth <= 800);
		if (widthRef.current) setTableWidth(widthRef.current.clientWidth);
	};

	return (
		<DataContext.Provider
			value={{
				widthRef,
				requestVariables,
				setRequestVariables,
				activeCountries,
				setActiveCountries,
				showedScreen,
				setShowedScreen,
				isMobile,
				setIsMobile,
				tableWidth,
				setTableWidth,
				pageHeight,
				setPageHeight
			}}>
			{props.children}
		</DataContext.Provider>
	);
}

export {DataContext, DataProvider};
